import Vue from "vue";
import { httpClient, jwt } from '@/app/shared/services';
import VueAxios from "vue-axios";

class ApiGateway {
  /**
   * @constructor ApiGateway
   */
  constructor() {
    /** Initializing the configuration of apiGateway */
    this.initApiGateway();
  }

  initApiGateway() {
    
    // axios.interceptors.request.use(config => {
    //   this.$Progress.start(); // for every request start the progress
    //   return config;
    // });
    
    // axios.interceptors.response.use(response => {
    //   this.$Progress.finish(); // finish when a response is received
    //   return response;
    // });

    Vue.use(VueAxios, httpClient);
    // Vue.axios.defaults.baseURL = Config.API_AUTH_URL;

    // this.setHeader();

  };

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${jwt.getToken()}`;
  };

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`ApiGateway ${error}`);
    });
  };

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`ApiGateway ${error}`);
    });
  };

  post(resource, params) {
    if(jwt.getToken()) {
      // Vue.axios.defaults.baseURL = Config.API_URL;
    }
    return Vue.axios.post(`${resource}`, params);
  };

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  };

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  };

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`ApiGateway ${error}`);
    });
  };

}

/** Creating the instance of apiGateway */
const api = new ApiGateway();

export { api };